module.exports = __webpack_public_path__ + "static/media/getintouchwith.37a41e66.png";